import React from "react";
interface Props {
  text: string;
  url: string;
  image: string;
  isTallCarouselMember?: boolean;
}
const OtherProductsCarouselPromotionMember = ({
  text,
  url,
  image,
  isTallCarouselMember = false
}: Props) => <li data-sentry-component="OtherProductsCarouselPromotionMember" data-sentry-source-file="OtherProductsCarouselPromotionMember.tsx">
    <div className={`other-products__container${isTallCarouselMember ? " other-products__container--vertical" : ""}`} style={isTallCarouselMember ? {
    backgroundImage: `url(https://cdnimg.webstaurantstore.com/${image})`,
    backgroundSize: "cover",
    backgroundPosition: "center"
  } : {
    backgroundImage: `url(https://cdnimg.webstaurantstore.com/${image})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    width: "220px"
  }}>
      <div className="other-products__content">
        <h3 className="other-products__title">{text}</h3>
        <a className="btn btn-small btn-primary" href={url} aria-label="Shop this Line">
          Shop this Line
        </a>
      </div>
    </div>
  </li>;
export default OtherProductsCarouselPromotionMember;